import { TooltipController } from "./tooltipController";

interface TooltipRegistration {
  controller: TooltipController;
  teardown: () => void;
}

const registry = new WeakMap<Document, TooltipRegistration>();

export const attachTooltipController = (ownerDocument: Document): (() => void) => {
  const registered = registry.get(ownerDocument);
  if (registered) return registered.teardown;

  const abortController = new AbortController();
  const controller = new TooltipController(ownerDocument);
  const teardown = (): void => {
    if (registry.get(ownerDocument)?.teardown !== teardown) return;
    registry.delete(ownerDocument);
    abortController.abort();
    controller.destroy();
  };

  registry.set(ownerDocument, { controller, teardown });
  controller.start(abortController.signal);
  return teardown;
};

export const hideTooltipForAnchor = (anchor: HTMLElement): void => {
  registry.get(anchor.ownerDocument)?.controller.hideForAnchor(anchor);
};

export const refreshTooltipForAnchor = (anchor: HTMLElement): void => {
  registry.get(anchor.ownerDocument)?.controller.refreshForAnchor(anchor);
};

export const reopenTooltipForAnchor = (anchor: HTMLElement): void => {
  registry.get(anchor.ownerDocument)?.controller.reopenForAnchor(anchor);
};
